<template>
  <div>
    <v-row class="text-center" no-gutters>
      <v-col>
        <div class="d-flex flex-column align-center pa-10 ga-6">
          <div class="tile__visual bg-surface-pink-subtle">
            <app-material-icon
              name="folder_check"
              color="icon-pink"
              filled
            />
          </div>
          <div class="d-flex flex-column ga-2">
            <p class="heading-sm-bold text-text-primary">
              {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.specificNeed') }}
            </p>
            <div class="text-text-tertiary">
              {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.activateDataRoom') }}
            </div>
          </div>
          <app-button data-locator="configure-button" @click="$emit('configureClicked')">
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.configure') }}
          </app-button>
        </div>
      </v-col>
      <v-divider vertical color="border-primary"/>
      <v-col>
        <div class="d-flex flex-column align-center pa-10 ga-6">
          <div class="tile__visual bg-surface-grey-subtle">
            <app-material-icon
              name="mail"
              color="icon-grey"
            />
          </div>
          <div class="d-flex flex-column ga-2">
            <p class="heading-sm-bold">
              {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.recurringNeed') }}
            </p>
            <div>
              {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.contactUsForSubscription') }}
            </div>
          </div>
          <app-button
            data-locator="contact-us-button"
            @click="$emit('requestActivation')"
          >
            {{ $t('projects.dialogs.ProjectsNewDataroomDialogChooseFormula.contactUs') }}
          </app-button>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ProjectsNewDataroomDialogChooseFormula',
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.tile__visual {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  @include border-radius('border-radius-2');
  overflow: hidden;
}
</style>
